import React from 'react';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import TypographyElements from '../../../foundation/typography/typography-element/typography-elements';

// eslint-disable-next-line jest/require-hook
dayjs.extend(utc);
// eslint-disable-next-line jest/require-hook
dayjs.extend(timezone);
// eslint-disable-next-line jest/require-hook
dayjs.tz.setDefault('Europe/Rome');

export interface IElapsedTime {
  modifyDate: string;
}

const ElapsedTime: React.FC<IElapsedTime> = ({ modifyDate }) => {
  const [date, time] = modifyDate.split(' ');
  const [day, month, year] = date.split('/');
  const [hours, minutes, seconds] = time.split(':');

  const modifyDateFromServer = dayjs(new Date(+year, +month - 1, +day, +hours, +minutes, +seconds));
  const now = dayjs();
  const diffDate = now.diff(modifyDateFromServer, 'second');

  const diffObject = [
    {
      value: Math.floor(diffDate), // seconds
      text: {
        single: 'SECONDO FA',
        multiple: 'SECONDI FA',
      },
    },
    {
      value: Math.floor(diffDate / 60), // minutes
      text: {
        single: 'MINUTO FA',
        multiple: 'MINUTI FA',
      },
    },
    {
      value: Math.floor(diffDate / (60 * 60)), // hours
      text: {
        single: 'ORA FA',
        multiple: 'ORE FA',
      },
    },
    {
      value: Math.floor(diffDate / (60 * 60 * 24)), // days
      text: {
        single: 'GIORNO FA',
        multiple: 'GIORNI FA',
      },
    },
    {
      value: Math.floor(diffDate / (60 * 60 * 24 * 30)), // months
      text: {
        single: 'MESE FA',
        multiple: 'MESI FA',
      },
    },
    {
      value: Math.floor(diffDate / (60 * 60 * 24 * 30 * 12)), // years
      text: {
        single: 'ANNO FA',
        multiple: 'ANNI FA',
      },
    },
  ];

  const [sorted] = diffObject.filter((a) => a.value > 0).sort((a, b) => a.value - b.value);

  return (
    <TypographyElements
      text={sorted ? `${sorted.value} ${sorted.text[sorted.value === 1 ? 'single' : 'multiple']}` : 'IN PUBBLICAZIONE'}
      typographyClass="ty-elements-medium--uppercase"
    />
  );
};

export default ElapsedTime;
